import * as React from "react";
import ModelContainer from "../../../components/model/ModelContainer";
import PageTitle from "../../../components/model/PageTitle";
import ModelTitle from "../../../components/model/ModelTitle";
import ModelInfo from "../../../components/model/ModelInfo";
import {GAEventModels} from "../../../utils/SendGAEvent";
import ModelDescription from "../../../components/model/ModelDescription";
import SummarizerModel from "./SummarizerModel";
import DisclaimerTitle from "../../../components/model/Disclaimer/DisclaimerTitle";
import DisclaimerDescription from "../../../components/model/Disclaimer/DisclaimerDescription";
import DisclaimerText from "../../../components/model/Disclaimer/DisclaimerText";
import TabPanel from "../../../components/model/TabPanel";

const Summarizer = () => {
    return <ModelContainer>
        <PageTitle/>
        <div>
            <ModelTitle>Summary Generation</ModelTitle>
            <ModelInfo model={GAEventModels.SUMMARIZER}/>
            <TabPanel
                modelName={GAEventModels.SUMMARIZER}
                modelDescription={<ModelDescription>Outputs a report of a tickers price with tags and explanation of major price movements</ModelDescription>}
                content={<SummarizerModel/>}
            />
            <hr/>
            <DisclaimerTitle>Disclaimer</DisclaimerTitle>
            <DisclaimerDescription/>
            <DisclaimerDescription>
                *Beta version only includes summaries for 50 selected symbols of the S&P 100
                <br/>
                {DisclaimerText}
            </DisclaimerDescription>
            <hr/>
        </div>
    </ModelContainer>;
};

export default Summarizer;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/Summarizer/index.tsx